module.exports = __webpack_public_path__ + "img/partners13.fbdf3867.jpg";